import { REHYDRATE } from "redux-persist";
import * as actionTypes from "./cartActionTypes";

const initialState = {
  restaurantCarts: {},
  lastUpdated: null,
  cart_expiration_minutes: 10,
};

function reducer(state = initialState, action: any) {
  switch (action.type) {
    case actionTypes.UPDATE_CART:
      // Deep clone to ensure new references and trigger React re-renders
      const newRestaurantCarts = JSON.parse(JSON.stringify(action.obj));
      
      return {
        ...state,
        restaurantCarts: newRestaurantCarts,
        lastUpdated: Date.now(),
      };

    case actionTypes.CLEAR_CART:
      return {
        ...state,
        restaurantCarts: {},
        lastUpdated: null,
      };

    case actionTypes.SET_CART_EXPIRATION:
      return {
        ...state,
        cart_expiration_minutes: action.cartExpMinutes,
      };

    case actionTypes.CLEAR_STORE_ITEM: {
      var key = action?.item;
      var obj: any = {};
      obj[key] = {};

      return {
        ...state,
        ...obj,
      };
    }

    case REHYDRATE:
      return {
        ...state,
        ...action.payload?.cart,
      };
      
    default:
      return state;
  }
}

export default reducer;